export const BASEURL = 'https://api.ciencia-acao.com.br/v1'



// WEBPACK FOOTER //
// ./src/api/api.variables.js